import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { TabButton } from "../../../ui/Tabs/TabButton";
import { TabsGroup } from "../../../ui/Tabs/TabsGroup";
import { VehicleMappingPayload } from "../useVehicleMaping";

export const NewPackageTabs: FunctionComponent<{
  data?: VehicleMappingPayload;
  selectTab(tabIndex: number): void;
  tabIndex: number;
}> = ({ data, selectTab, tabIndex }) => {
  const { t } = useTranslation();
  return (
    <TabsGroup className="mx-4 grid grid-cols-3 mt-2" id="new-package-tabs">
      <TabButton
        onClick={(): void => {
          selectTab(0);
        }}
        aria-label="vehicleMapping"
        selected={tabIndex === 0}
      >
        {t("packageEditor.parts")}
      </TabButton>
      <TabButton
        onClick={(): void => {
          selectTab(1);
        }}
        aria-label="vehicleMapping"
        selected={tabIndex === 1}
      >
        {t("packageEditor.vehicles")}
      </TabButton>
      <TabButton
        onClick={(): void => {
          selectTab(2);
        }}
        aria-label="vehicleMapping"
        disabled={!data?.totalSelected}
        selected={tabIndex === 2}
      >
        {t("packageEditor.info")}
      </TabButton>
    </TabsGroup>
  );
};
